import { useEffect, useRef } from 'react';
import { getCookie } from 'root/src/client/v2/browser/helpers/cookies';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { RedesignGiveawayWonModal } from 'root/src/client/v2/_pages/creator/redesign/RedesignGiveawayWonModal';
// Surfaces the redesign "you won" modal when a resolved giveaway for this creator has the viewer as a
// voucher owner. The legacy flow drove this off an SSE window event (`useGiveawayLifecycle` /
// `useSetupGiveawayListeners`); the redesign instead reacts to the polled `useCreatorGiveaways` data,
// presenting each won giveaway at most once (tracked in a ref so the panel's refetch never re-pops).
export const useCreatorGiveawayWon = ({ resolved, creatorUserId, creatorMnemonicId }) => {
    const { show } = useRedesignModal();
    const presentedIds = useRef(new Set());
    useEffect(() => {
        const viewerId = getCookie('userId');
        // The creator owns these giveaways; the win modal is for participants only (matches the legacy
        // `useGiveawayLifecycle`, which returns early when `isGiveawayOwner`).
        if (!viewerId || viewerId === creatorUserId) {
            return;
        }
        const wonGiveaway = resolved.find((giveaway) => {
            var _a;
            if (!giveaway.id || presentedIds.current.has(giveaway.id)) {
                return false;
            }
            return Boolean((_a = giveaway.vouchers) === null || _a === void 0 ? void 0 : _a.some(voucher => { var _a; return ((_a = voucher.owner) === null || _a === void 0 ? void 0 : _a.id) === viewerId; }));
        });
        if (!(wonGiveaway === null || wonGiveaway === void 0 ? void 0 : wonGiveaway.id)) {
            return;
        }
        presentedIds.current.add(wonGiveaway.id);
        show(<RedesignGiveawayWonModal creatorUserId={creatorUserId} creatorMnemonicId={creatorMnemonicId}/>);
    }, [resolved, creatorUserId, creatorMnemonicId, show]);
};
